class HomeLineUpSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const swiper = new Swiper('.'+this.el, {
      speed: 10000,
      loop: true,
      slidesPerView: 2,
      spaceBetween: 49,
      allowTouchMove: false,             // タッチ操作を無効にする
      preventClicks: true,               // スライダー上でのクリックを防ぐ
      preventClicksPropagation: true,    // クリックイベントの伝播を防ぐ
      autoplay: {
        delay: 0,  
      },
      breakpoints: {
        851: {
          slidesPerView: 3,
          spaceBetween: 90,
        }
      }
    })
  }
}
